import { useState, useEffect } from "react";

const usePassword = (passwordOne: string, passwordTwo: string) => {
    // booleans for password validations
    const [containsUL, setContainsUL] = useState(false); // uppercase letter
    const [containsLL, setContainsLL] = useState(false); // lowercase letter
    const [containsN, setContainsN] = useState(false); // number
    const [containsSC, setContainsSC] = useState(false); // special character
    const [contains10C, setContains10C] = useState(false); // min 10 characters
    const [passwordMatch, setPasswordMatch] = useState(false); // passwords match

    // checks all validations are true
    const [allValid, setAllValid] = useState(false);

    // labels and state boolean corresponding to each validation
    const mustContainData = [
        ["Una Letra Mayúscula (A-Z)", containsUL],
        ["Una Letra Minúscula (a-z)", containsLL],
        ["Un número (0-9)", containsN],
        ["Un carácter especial (!@#$.-)", containsSC],
        ["Al menos 10 carácteres", contains10C],
        ["Contraseñas iguales", passwordMatch],
    ];

    useEffect(() => {
        setContains10C(passwordOne.length >= 10);
        setContainsUL(passwordOne.toLowerCase() !== passwordOne);
        setContainsLL(passwordOne.toUpperCase() !== passwordOne);
        setContainsN(/\d/.test(passwordOne));
        setPasswordMatch(passwordOne.length > 0 && passwordOne === passwordTwo);
        setContainsSC(/[`!@#$%^&*()_+\-=\]{};':"\\|,.<>?~]/.test(passwordOne));
        setAllValid(
            containsUL &&
                containsLL &&
                containsN &&
                containsSC &&
                contains10C &&
                passwordMatch
        );
    }, [
        passwordOne,
        passwordTwo,
        containsUL,
        containsLL,
        containsN,
        containsSC,
        contains10C,
        passwordMatch,
    ]);

    return { allValid, mustContainData };
};

export default usePassword;
